import { render, staticRenderFns } from "./DrawerFaq.vue?vue&type=template&id=f4f13682&scoped=true&"
import script from "./DrawerFaq.vue?vue&type=script&lang=js&"
export * from "./DrawerFaq.vue?vue&type=script&lang=js&"
import style0 from "./DrawerFaq.vue?vue&type=style&index=0&id=f4f13682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f13682",
  null
  
)

export default component.exports